import Vue from 'vue';
import security from "../../../../main";
import { getApiBaseUrl } from "@/config.js";

const getI18n = () => {
    return Vue.prototype.$i18n;
}

const jsonHeader = function () {
    return {
        Authorization: 'Bearer ' + security.token (),
        "Content-Type": 'application/json'
    };
};

const expandArgs = function (url, args) {
    const base = url.startsWith("http://") || url.startsWith("https://") ? "" : getApiBaseUrl();
    let result = base + url;
    args.forEach((arg, index) => {
        result = result.replace("{" + index + "}", arg)
    });

    return result;
}

const checkError = (response) => {
    if (response.ok) {
        return response;
    }

    if (response.status === 204) {
        return response;
    }

    if (response.status === 401) {
        security.logout();
    } else {
        return new Promise((resolved, reject) => {
            response.json().then(data => {
                const i18n = getI18n();
                const isProd = import.meta.env.MODE === 'production';
                const message = isProd 
                    ? (i18n?.t?.('common.error.generic') || 'An error occurred')
                    : (data?.message || data?.error || `Request failed with status ${response.status}`);
                const details = !isProd ? `\n\nUrl: ${response.url}` : '';
                
                Vue.prototype.$bus.$emit(Vue.prototype.$events.alert.error, { 
                    message: message + details
                });
                
                reject(data);
            }).catch(e => {
                Vue.prototype.$bus.$emit(Vue.prototype.$events.alert.error, { 
                    message: `Request failed with status ${response.status}`
                });
                reject(e);
            });
        });
    }
}

export default {
    jsonHeader () {
        return jsonHeader();
    },

    get(url, ...args) {
        const expandedurl = expandArgs(url, args);
        return fetch(expandedurl, {
            method: "GET",
            headers: jsonHeader(),
        })
            .catch(e => {
                return Promise.reject(e);
            })
            .then(checkError)
            .then(data => data.json())
            .catch(error => {
                return Promise.reject(error);
            })
    },

    get2(url, ...args) {
    const expandedUrl = expandArgs(url, args);

    return fetch(expandedUrl, { method: "GET", headers: jsonHeader() })
        .then(async (res) => {
            if (!res.ok) {
                let body;
                try { body = await res.text(); } catch { body = ""; }
                return { ok: false, status: res.status, body };
            }
            return { ok: true, data: await res.json() };
        })
        .catch(err => {
            // Netzwerk-/CORS-Fehler etc.
            return { ok: false, network: true, error: String(err) };
        });
},

    post(url, body, ...args) {
        return fetch(expandArgs(url, args), {
            method: "POST",
            headers: jsonHeader(),
            body: JSON.stringify(body),
        })
            .then(checkError)
            .then(data => data.json())
            .catch(error => {
                return Promise.reject(error);
            });
    },

    postVoid(url, body, ...args) {
        return fetch(expandArgs(url, args), {
            method : "POST",
            headers: jsonHeader(),
            body   : JSON.stringify(body),
        }).then(checkError).catch(e => {
            return new Promise((resolved, reject) => {
                reject(e);
            });
        })
    },

    put(url, body, ...args) {
        return fetch(expandArgs(url, args), {
            method: "PUT",
            headers: jsonHeader(),
            body: JSON.stringify(body),
        })
            .then(checkError)
            .then(data => data.json())
            .catch(error => {
                return Promise.reject(error);
            })
    },

    putVoid(url, body, ...args) {
        return fetch(expandArgs(url, args), {
            method : "PUT",
            headers: jsonHeader(),
            body   : JSON.stringify(body),
        }).then(checkError).catch(e => {
            return new Promise((resolved, reject) => {
                reject(e);
            });
        })
    },

    putRawVoid(url, body, ...args) {
        return fetch(expandArgs(url, args), {
            method : "PUT",
            headers: jsonHeader(),
            body   : body,
        }).then(checkError).catch(e => {
            return new Promise((resolved, reject) => {
                reject(e);
            });
        })
    },

    delete(url, body, ...args) {
        return fetch(expandArgs(url, args), {
            method: "DELETE",
            headers: jsonHeader(),
            body   : body,
        })
            .then(checkError)
            .then(data => data.json())
            .catch(error => {
                console.log("error", error);
                return Promise.reject(error);
            })
    },

    deleteVoid(url, body, ...args) {
        return fetch(expandArgs(url, args), {
            method : "DELETE",
            headers: jsonHeader(),
            body   : body
        }).then(checkError).catch(e => {
            return new Promise((resolved, reject) => {
                reject(e);
            });
        })
    },
}